// src/MathTools/RadioactiveDecayTool.js

import React, { useState } from "react";
import CoordinatePlane from "./CoordinatePlane";

export default function RadioactiveDecayTool({
  initialN0 = 1000,
  initialK  = 0.1,
  timeMax   = 50,
  width     = 400,
  height    = 300
}) {
  const [N0, setN0] = useState(initialN0);
  const [k,  setK ] = useState(initialK);

  // Sample the function N(t)=N0 e^{-k t}
  // from t=0..timeMax
  const stepCount = 100;
  const dt = timeMax / stepCount;

  const lines = [];
  let maxN = 0;
  for (let i=0; i<=stepCount; i++){
    const t = i*dt;
    const val = N0 * Math.exp(-k*t);
    if (val>maxN) maxN=val;

    lines.push({
      start: [t, val],
      end:   [t, val],
      color: "green"
    });
  }

  // Domain for t => [0..timeMax].
  // Range for N => [0.. ~some fraction above maxN].
  const Nmax = maxN * 1.1;

  return (
    <div style={{ border:"1px solid #ccc", padding:8 }}>
      <h4>Radioactive Decay: N(t)=N0 e<sup>-k t</sup></h4>
      <div style={{ marginBottom:8 }}>
        <label>
          N0:
          <input
            type="number"
            value={N0}
            onChange={e => setN0(parseFloat(e.target.value)||1000)}
            style={{ width:80, marginLeft:6 }}
          />
        </label>
        &nbsp;&nbsp;
        <label>
          k:
          <input
            type="number"
            step="0.01"
            value={k}
            onChange={e => setK(parseFloat(e.target.value)||0.1)}
            style={{ width:80, marginLeft:6 }}
          />
        </label>
      </div>
      <CoordinatePlane
        width={width}
        height={height}
        xDomain={[0, timeMax]}
        yDomain={[0, Nmax]}
        lines={lines}
        showAxes
        axisMode="border"
        disablePlot={true}
      />
      <p style={{ fontStyle:"italic", fontSize:"0.9em", marginTop:8 }}>
        Try changing N0 and k. The half‐life is 
        t<sub>1/2</sub>= ln(2)/k &approx; {(0.693/k).toFixed(2)} (approx).
      </p>
    </div>
  );
}
